import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  ButtonGroup,
  Divider,
  Typography,
} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import GlobalDateField from "../../global-fields/GlobalDateField";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {setUiData} from "../../../store/uiSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import {
  handleFileUploadWithoutVids,
  initialFormValidations,
  removeCookies,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {MANDATORY_QUES} from "../../../constants/constants";
import GlobalModal from "../../global-fields/GlobalModal";
import GlobalErrorMsgBox from "../../global-fields/GlobalErrorMsgBox";
import styled from "styled-components";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {FaExternalLinkAlt} from "react-icons/fa";
import {TbRefresh} from "react-icons/tb";
import {IoMdClose} from "react-icons/io";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import dayjs from "dayjs";
import {MdOutlineRemoveRedEye} from "react-icons/md";
import GlobalRadio from "../../global-fields/GlobalRadio";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const ExtentOfProtectionMenuItems = [
  {name: "Complete", value: "Complete"},
  {name: "Partial", value: "Partial"},
  {name: "None", value: "None"},
];

const StepFourForm = ({leftGridWidth}) => {
  const vaultLimit = 10;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep4Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  //   const [totalVault, setTotalVaults] = useState(1);
  const [disableDraft, setDisableDraft] = useState(false);
  const propStep4DataMemoize = useMemo(() => propStep4Data, [propStep4Data]);

  const initialValues = {
    step: 4,
    safe_vaults: propStep4DataMemoize?.safe_vaults?.length
      ? propStep4DataMemoize?.safe_vaults?.map((item) => ({
          safe_or_vault: item.safe_or_vault,
          particulars: item.particulars,
          company_name: item.company_name,
          extent: item.extent ?? "Complete",
          ul_certificate_no: item.ul_certificate_no,
          ul_certificate_file: item.ul_certificate_file ?? null, // File input
          expiry_date: item.expiry_date,
        }))
      : [
          {
            safe_or_vault: "",
            particulars: "",
            company_name: "",
            extent: "Complete",
            ul_certificate_no: "",
            ul_certificate_file: null,
            expiry_date: "",
          },
        ],
  };

  // useEffect(() => {
  //   if (propStep4DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep4DataMemoize]);

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(
      setUiData({
        showLoader: true,
      })
    );

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      step: proposalStep,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
    };

    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }

    const formData = new FormData();
    formData.append("proposal_id", data.proposal_id);
    formData.append("step", data.step);
    formData.append("user_id", data.user_id);
    data?.safe_vaults.forEach((item, index) => {
      Object.entries(item).forEach(([key, value]) => {
        if (key === "ul_certificate_no") {
          formData.append(`safe_vaults[${index}][${key}]`, value ? value : "");
        } else if (key === "expiry_date") {
          formData.append(
            `safe_vaults[${index}][${key}]`,
            value ? dayjs(value).format("MM-DD-YYYY") : ""
          );
        } else if (key === "ul_certificate_file") {
          // Append file separately
          if (value instanceof File) {
            formData.append(`safe_vaults[${index}][${key}]`, value);
          } else if (value !== null) {
            formData.append(`safe_vaults[${index}][${key}]`, value);
          }
        } else {
          formData.append(`safe_vaults[${index}][${key}]`, value);
        }
      });
    });

    const options = {
      method: PROPOSAL_FORM.method,
      body: formData,
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      safe_vaults: Yup.array().of(
        Yup.object({
          // safe_or_vault: Yup.string()
          //   .oneOf(["safe", "vault"], "Invalid value")
          //   .required(MANDATORY_QUES),
         // particulars: Yup.string().required(MANDATORY_QUES),
          //company_name: Yup.string().required(MANDATORY_QUES),
          extent: Yup.mixed()
            .nullable()
            .test(
              "required",
              MANDATORY_QUES,
              (value) => value !== null && value !== undefined
            ),
          ul_certificate_no: Yup.string()
            .nullable()
            .max(33, "Maximum 32 Characters Allowed."),
          ul_certificate_file: Yup.mixed()
            .nullable()
            .test("file-or-url", MANDATORY_QUES, (value) => {
              if (!value) return true; // No Validation
              // if (!value) return false; // If value is null/undefined, it's invalid
              if (typeof value === "string" && value.includes("https://"))
                return true; // Valid URL
              if (value instanceof File) return true; // Valid File
              return false; // Invalid case
            }),
          expiry_date: Yup.string(),
        })
      ),
    }),
    onSubmit: (values) => {
      //console.log("Form submitted 4:", values);
      handleStepData(values);
    },
  });

  const handlePlus = useCallback(() => {
    //setTotalVaults((prev) => prev + 1);
    formik.setValues((prevValues) => ({
      safe_vaults: [
        ...prevValues?.safe_vaults,
        {
          particulars: "",
          extent: "Complete",
          company_name: "",
          ul_certificate_no: "",
          ul_certificate_file: null,
          expiry_date: "",
        },
      ],
    }));
  }, [formik]);

  const handleRemove = useCallback(
    (val) => {
      if (!val) {
        setOpenModal(false);
        setModalContent("");
        return;
      }
      //setTotalVaults((prev) => Math.max(prev - 1, 1)); // Ensures it never goes below 1
      formik.setValues((prevValues) => ({
        safe_vaults:
          prevValues?.safe_vaults.length > 1
            ? prevValues?.safe_vaults.slice(0, -1)
            : prevValues?.safe_vaults,
      }));
      setOpenModal(false);
      setModalContent("");
    },
    [formik]
  );

  const handleConfirmation = (index, type) => {
    setOpenModal(true);
    setModalContent(`You Want To Remove Vault ${index + 1}.`);
  };

  // console.log("formik", formik.dirty, formik.values, formik.errors);
  // console.log("propStep4DataMemoize", propStep4DataMemoize);

  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 4) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };

  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}{" "}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Safes and Vaults</h2>

            <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
              <div className={style.propoformCountBtn}>
                <p> Number of Safes or Vaults: </p>
                <div className="countGroupBtn">
                  <ButtonGroup size="small" aria-label="Small button group">
                    <Button
                      variant="contained"
                      onClick={() => handleConfirmation(null)}
                      disabled={formik.values?.safe_vaults.length < 2}
                    >
                      -
                    </Button>
                    <Button
                      style={{
                        pointerEvents: "none",
                        borderColor: "rgb(236 236 236)",
                      }}
                    >
                      {formik.values?.safe_vaults.length}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handlePlus}
                      disabled={formik.values?.safe_vaults.length >= vaultLimit}
                    >
                      +
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </Grid>

            <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
              <h2 className={style.formTitleh2}>10) Safes and Vaults</h2>
            </Grid>
            {formik.values?.safe_vaults.map((item, index) => (
              <>
                {" "}
                <Accordion
                  key={index}
                  defaultExpanded={false}
                  className="proposal_accordion"
                  style={
                    formik?.errors?.safe_vaults?.length
                      ? {borderColor: "#FF2116"}
                      : {}
                  }
                >
                  <div className="premiseAccordionDiv">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`safe_vaults${index + 1}-content`}
                      id={`safe_vaults${index + 1}-header`}
                    >
                      <Typography component="h4">
                        Safe/Vault {index + 1}
                      </Typography>
                    </AccordionSummary>
                    <Button
                      className={style.premiseCloseBtn}
                      variant="contained"
                      color="error"
                      onClick={() => handleConfirmation(index)}
                      disabled={formik.values?.safe_vaults?.length === 1}
                    >
                      <IoMdClose />
                    </Button>
                  </div>
                  <AccordionDetails>
                    <form
                      autoComplete="false"
                      autoSave="false"
                      onSubmit={handleCustomSubmit}
                    >
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Information/Declaration is for *
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 5}}>
                          <GlobalRadio
                            title="Safe"
                            selected={
                              formik.values?.safe_vaults?.[index]
                                ?.safe_or_vault === "safe"
                            }
                            onClick={() =>
                              formik.setFieldValue(
                                `safe_vaults[${index}].safe_or_vault`,
                                "safe"
                              )
                            }
                            error={
                              formik.touched?.safe_vaults?.[index]
                                ?.safe_or_vault &&
                              Boolean(
                                formik.errors?.safe_vaults?.[index]
                                  ?.safe_or_vault
                              )
                            }
                            errorText={
                              formik.touched?.safe_vaults?.[index]
                                ?.safe_or_vault &&
                              formik.errors?.safe_vaults?.[index]?.safe_or_vault
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 5}}>
                          <GlobalRadio
                            title="Vault"
                            selected={
                              formik.values?.safe_vaults?.[index]
                                ?.safe_or_vault === "vault"
                            }
                            onClick={(e) => {
                              e.preventDefault();
                              formik.setFieldValue(
                                `safe_vaults[${index}].safe_or_vault`,
                                "vault"
                              );
                            }}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} sx={{mt: 1}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Give full particulars of each Safe or vault *
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 5}}>
                          <GlobalTextField
                            name={`safe_vaults[${index}].particulars`}
                            id={`safe_vaults_${index}_particulars`}
                            value={
                              formik.values?.safe_vaults[index].particulars
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.safe_vaults?.[index]
                                ?.particulars &&
                              Boolean(
                                formik.errors?.safe_vaults?.[index]?.particulars
                              )
                            }
                            helperText={
                              formik.touched?.safe_vaults?.[index]
                                ?.particulars &&
                              formik.errors?.safe_vaults?.[index]?.particulars
                            }
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Give details of all electrical alarm systems
                            protecting above safes or vaults.
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 5}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <h3 className={style.htitleText}>
                              Name of the Protective Company *
                            </h3>
                          </Box>
                          <GlobalTextField
                            name={`safe_vaults[${index}].company_name`}
                            id={`safe_vaults_${index}_company_name`}
                            value={
                              formik.values?.safe_vaults[index].company_name
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.safe_vaults?.[index]
                                ?.company_name &&
                              Boolean(
                                formik.errors?.safe_vaults?.[index]
                                  ?.company_name
                              )
                            }
                            helperText={
                              formik.touched?.safe_vaults?.[index]
                                ?.company_name &&
                              formik.errors?.safe_vaults?.[index]?.company_name
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 5}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <h3 className={style.htitleText}>
                              Extent of Protection
                            </h3>
                          </Box>
                          <GlobalSelectField
                            labelId={`safe_vaults.${index}.extent`}
                            value={formik.values?.safe_vaults[index]?.extent}
                            onChange={(e) =>
                              formik.setFieldValue(
                                `safe_vaults.${index}.extent`,
                                e.target.value
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.safe_vaults?.[index]?.extent &&
                              Boolean(
                                formik.errors?.safe_vaults?.[index]?.extent
                              )
                            }
                            helperText={
                              formik.touched?.safe_vaults?.[index]?.extent
                                ? formik.errors?.safe_vaults?.[index]?.extent
                                : ""
                            }
                            menuItems={ExtentOfProtectionMenuItems}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12, md: 5}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <h3 className={style.htitleText}>
                              U.L. Certificate No.
                            </h3>
                          </Box>
                          <GlobalTextField
                            name={`safe_vaults[${index}].ul_certificate_no`}
                            id={`safe_vaults_${index}_ul_certificate_no`}
                            value={
                              formik.values?.safe_vaults?.[index]
                                ?.ul_certificate_no
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.safe_vaults?.[index]
                                ?.ul_certificate_no &&
                              Boolean(
                                formik.errors?.safe_vaults?.[index]
                                  ?.ul_certificate_no
                              )
                            }
                            helperText={
                              formik.touched?.safe_vaults?.[index]
                                ?.ul_certificate_no &&
                              formik.errors?.safe_vaults?.[index]
                                ?.ul_certificate_no
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 5}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <h3 className={style.htitleText}>
                              Date of Expiration
                            </h3>
                          </Box>
                          <GlobalDateField
                            name={`safe_vaults[${index}].expiry_date`}
                            value={
                              formik.values?.safe_vaults[index].expiry_date
                            }
                            onChange={(newValue) =>
                              formik.setFieldValue(
                                `safe_vaults[${index}].expiry_date`,
                                newValue
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.safe_vaults?.[index]
                                ?.expiry_date &&
                              Boolean(
                                formik.errors?.safe_vaults?.[index]?.expiry_date
                              )
                            }
                            helperText={
                              formik.touched?.safe_vaults?.[index]
                                ?.expiry_date &&
                              formik.errors?.safe_vaults?.[index]?.expiry_date
                            }
                            disablePast
                            clearBtn={
                              formik.values?.safe_vaults[index].expiry_date !==
                              ""
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid
                          size={{xs: 12, md: 5}}
                          sx={{mt: 3}}
                          className="choosefileBtn"
                        >
                          <Box sx={{color: "#000", mb: 1}}>
                            Enclose U.L. Certificates where issued
                          </Box>
                          <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUploadIcon />}
                          >
                            {formik.values?.safe_vaults[index]
                              .ul_certificate_file?.name ? (
                              <span>
                                {" "}
                                {
                                  formik.values?.safe_vaults[index]
                                    .ul_certificate_file.name
                                }{" "}
                              </span>
                            ) : formik.values?.safe_vaults[
                                index
                              ].ul_certificate_file?.includes("https://") ? (
                              <>
                                <span className={style.safeVFile}>
                                  {
                                    formik.values?.safe_vaults[
                                      index
                                    ].ul_certificate_file.split("/images/")[1]
                                  }
                                </span>
                              </>
                            ) : (
                              "Upload file"
                            )}
                            <VisuallyHiddenInput
                              type="file"
                              accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                              // onChange={(event) =>
                              //   formik.setFieldValue(
                              //     `safe_vaults[${index}].ul_certificate_file`,
                              //     event.target.files[0]
                              //   )
                              // }
                              onChange={(event) =>
                                handleFileUploadWithoutVids({
                                  event,
                                  fieldName: `safe_vaults[${index}].ul_certificate_file`,
                                  formik,
                                  onError: (message) =>
                                    GlobalNotificationPopup({
                                      type: "error",
                                      message,
                                    }),
                                })
                              }
                            />
                          </Button>

                          <div className={style.fileBtnMain}>
                            {formik.values?.safe_vaults[index]
                              .ul_certificate_file &&
                            formik.values?.safe_vaults[index]
                              .ul_certificate_file !== "" ? (
                              <>
                                <span
                                  style={{
                                    cursor: "pointer",
                                    // marginLeft: "5px",
                                    // backgroundColor: "#004F71",
                                    borderRadius: "10px",
                                    color: "rgb(0 79 113)",
                                    // padding: "3px 5px",
                                    display: "block",
                                    marginTop: "10px",
                                    textAlign: "right",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() => {
                                    if (
                                      formik.values?.safe_vaults[index]
                                        .ul_certificate_file?.name
                                    ) {
                                      window.open(
                                        URL.createObjectURL(
                                          formik.values?.safe_vaults[index]
                                            .ul_certificate_file
                                        ),
                                        "_blank"
                                      );
                                      return;
                                    }

                                    if (
                                      formik.values?.safe_vaults[
                                        index
                                      ].ul_certificate_file?.includes(
                                        "https://"
                                      )
                                    ) {
                                      window.open(
                                        formik.values?.safe_vaults[index]
                                          .ul_certificate_file,
                                        "_blank"
                                      );
                                    }
                                    return;
                                  }}
                                >
                                  View <MdOutlineRemoveRedEye />
                                </span>
                                <span
                                  style={{
                                    cursor: "pointer",
                                    // marginLeft: "5px",
                                    // backgroundColor: "#004F71",
                                    borderRadius: "10px",
                                    color: "rgb(0 79 113)",
                                    // padding: "3px 5px",
                                    display: "block",
                                    marginTop: "10px",
                                    textAlign: "right",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  onClick={() =>
                                    // window.open(
                                    //   formik.values?.safe_vaults[index]
                                    //     .ul_certificate_file,
                                    //   "_blank"
                                    // )
                                    formik.setFieldValue(
                                      `safe_vaults[${index}].ul_certificate_file`,
                                      ""
                                    )
                                  }
                                >
                                  Clear <TbRefresh />
                                </span>
                              </>
                            ) : null}
                          </div>

                          {formik.touched?.safe_vaults?.[index]
                            ?.ul_certificate_file &&
                          formik?.errors?.safe_vaults?.[index]
                            ?.ul_certificate_file ? (
                            <GlobalErrorMsgBox
                              errMessage={
                                formik?.errors?.safe_vaults?.[index]
                                  ?.ul_certificate_file
                              }
                            />
                          ) : null}
                        </Grid>
                      </Grid>
                    </form>
                  </AccordionDetails>
                </Accordion>
                {formik?.errors?.safe_vaults?.length ? (
                  <small style={{color: "#FF2116"}}>
                    Mandatory Fields Are Missing!
                  </small>
                ) : null}
              </>
            ))}
          </Box>
        </motion.div>
        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            (formik.errors?.safe_vaults?.length == 0 ||
              (formik.values?.safe_vaults?.[0]?.particulars !== "" &&
                formik.values?.safe_vaults?.[0]?.company_name !== "")) &&
            !formik.dirty &&
            propStep4DataMemoize !== null
          }
          // nextPage={ formik.dirty || propStep4DataMemoize === null ? false : true}
          //handleSave={handleSave}
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />

        <GlobalModal
          open={openModal}
          maxWidth="sm"
          handleClose={() => setOpenModal(false)}
          aria-labelledby="claim-history"
          closeIcon={true}
          title={"Are you sure?"}
          dialogTitleClass={style.claimPopTitle}
          disableBackdropClick={false}
          dialogContent={
            <Grid container spacing={0}>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center", mb: 3}}>
                {/* <BiErrorCircle color="#FF2116" size={40}/> */}
                <p>{modalContent}</p>
              </Grid>
              <Grid
                size={{xs: 12, md: 12}}
                sx={{textAlign: "center"}}
                className={style.consentContentBtn}
              >
                <Button
                  variant="contained"
                  sx={{mr: 2}}
                  onClick={() => handleRemove(true)}
                >
                  YES
                </Button>
                <Button variant="contained" onClick={() => handleRemove(false)}>
                  NO
                </Button>
              </Grid>
            </Grid>
          }
        ></GlobalModal>
      </section>
    </>
  );
};

export default StepFourForm;
